/* eslint-disable complexity */
const validate = values => {
    const errors = {};

    if (!values.pgRoutingRequestList || !values.pgRoutingRequestList.length) {
    } else {
        const routingErrors = [];
        values.pgRoutingRequestList.forEach((route, routeIndex) => {
            if (
                route.pgPercentage.payu === '' ||
                route.pgPercentage.payu < 0 ||
                route.pgPercentage.payu > 100 ||
                (route.pgPercentage.payu &&
                    JSON.stringify(route.pgPercentage.payu).indexOf('.') > -1)
            ) {
                routingErrors[routeIndex] = {
                    pgPercentage: {
                        payu:
                            'Please enter a value between 0 and 100 w/o decimals',
                    },
                };
            }
            if (
                route.pgPercentage.migs === '' ||
                route.pgPercentage.migs < 0 ||
                route.pgPercentage.migs > 100 ||
                (route.pgPercentage.migs &&
                    JSON.stringify(route.pgPercentage.migs).indexOf('.') > -1)
            ) {
                routingErrors[routeIndex] = {
                    pgPercentage: {
                        migs:
                            'Please enter a value between 0 and 100 w/o decimals',
                    },
                };
            }
            if (
                route.pgPercentage.cca === '' ||
                route.pgPercentage.cca < 0 ||
                route.pgPercentage.cca > 100 ||
                (route.pgPercentage.cca &&
                    JSON.stringify(route.pgPercentage.cca).indexOf('.') > -1)
            ) {
                routingErrors[routeIndex] = {
                    pgPercentage: {
                        cca:
                            'Please enter a value between 0 and 100 w/o decimals',
                    },
                };
            }
            if (
                route.pgPercentage.cybs === '' ||
                route.pgPercentage.cybs < 0 ||
                route.pgPercentage.cybs > 100 ||
                (route.pgPercentage.cybs &&
                    JSON.stringify(route.pgPercentage.cybs).indexOf('.') > -1)
            ) {
                routingErrors[routeIndex] = {
                    pgPercentage: {
                        cybs:
                            'Please enter a value between 0 and 100 w/o decimals',
                    },
                };
            }

            if (
                route.pgPercentage.hdfc === '' ||
                route.pgPercentage.hdfc < 0 ||
                route.pgPercentage.hdfc > 100 ||
                (route.pgPercentage.hdfc &&
                    JSON.stringify(route.pgPercentage.hdfc).indexOf('.') > -1)
            ) {
                routingErrors[routeIndex] = {
                    pgPercentage: {
                        hdfc:
                            'Please enter a value between 0 and 100 w/o decimals',
                    },
                };
            }

            if (
                route.pgPercentage.bdk === '' ||
                route.pgPercentage.bdk < 0 ||
                route.pgPercentage.bdk > 100 ||
                (route.pgPercentage.bdk &&
                    JSON.stringify(route.pgPercentage.bdk).indexOf('.') > -1)
            ) {
                routingErrors[routeIndex] = {
                    pgPercentage: {
                        bdk:
                            'Please enter a value between 0 and 100 w/o decimals',
                    },
                };
            }

            if (
                route.pgPercentage.fiserv === '' ||
                route.pgPercentage.fiserv < 0 ||
                route.pgPercentage.fiserv > 100 ||
                (route.pgPercentage.fiserv &&
                    JSON.stringify(route.pgPercentage.fiserv).indexOf('.') > -1)
            ) {
                routingErrors[routeIndex] = {
                    pgPercentage: {
                        fiserv:
                            'Please enter a value between 0 and 100 w/o decimals',
                    },
                };
            }

            if (
                route.pgPercentage.mpgs === '' ||
                route.pgPercentage.mpgs < 0 ||
                route.pgPercentage.mpgs > 100 ||
                (route.pgPercentage.mpgs &&
                    JSON.stringify(route.pgPercentage.mpgs).indexOf('.') > -1)
            ) {
                routingErrors[routeIndex] = {
                    pgPercentage: {
                        mpgs:
                            'Please enter a value between 0 and 100 w/o decimals',
                    },
                };
            }

            let pgPercentageTotal = 0;
            for (const paymentGateway in route.pgPercentage) {
                if (route.pgPercentage.hasOwnProperty(paymentGateway)) {
                    pgPercentageTotal += parseInt(
                        route.pgPercentage[paymentGateway],
                        10
                    );
                }
            }

            if (pgPercentageTotal !== 100) {
                const pgs = Object.keys(route.pgPercentage);
                routingErrors[routeIndex] = {
                    pgPercentage: {
                        [pgs[0]]: 'Total of all PG percentages should be 100',
                    },
                };
            }
        });

        errors.pgRoutingRequestList = routingErrors;
    }

    return errors;
};

export default validate;
